import React from 'react';
import ListItemText from '@mui/material/ListItemText';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import { Link, useLocation } from 'react-router';
import NavigationContainer from '../navigation/NavigationContainer';
import useSuspenseFetch from '../hooks/useSuspenseFetch';

const SuperAdminNavigationListItem = ({ text, url, icon }) => {
    const location = useLocation();

    return (
        <ListItemButton component={Link} to={url} selected={location.pathname === url}>
            {icon && <ListItemIcon>{icon}</ListItemIcon>}
            <ListItemText primary={text} />
        </ListItemButton>
    );
};

const SuperAdminNavigation = ({ width = null, isSmallScreen, open, onClose }) => {
    const { data: user } = useSuspenseFetch('user');
    const { permissions: userPermissions } = user;
    const canManageAccounts = userPermissions.includes('manage:accounts');
    const canManageCampaigns = userPermissions.includes('manage:campaigns');
    const canManageTemplates = userPermissions.includes('manage:templates');
    const canManageNotifications = userPermissions.includes('manage:notifications');
    const canManageEmails = userPermissions.includes('manage:emails');
    const canReadAuditActions = userPermissions.includes('read:audit-actions');
    const canReadImports = userPermissions.includes('read:imports');
    const canManageFeatures = userPermissions.includes('manage:features');

    return (
        <>
            <NavigationContainer width={width} isSmallScreen={isSmallScreen} open={open} onClose={onClose}>
                <List>
                    {canManageAccounts && <SuperAdminNavigationListItem text="Accounts" url="/superadmin/accounts" />}
                    {canManageCampaigns && <SuperAdminNavigationListItem text="Campaigns" url="/superadmin/campaigns" />}
                    {canManageTemplates && <SuperAdminNavigationListItem text="Templates" url="/superadmin/templates" />}
                    {canManageEmails && <SuperAdminNavigationListItem text="Content" url="/superadmin/content" />}
                    {canManageNotifications && <SuperAdminNavigationListItem text="Announcements" url="/superadmin/notifications" />}
                    {canReadAuditActions && <SuperAdminNavigationListItem text="Auditing" url="/superadmin/auditing" />}
                    {canReadImports && <SuperAdminNavigationListItem text="Imports" url="/superadmin/imports" />}
                    {canManageFeatures && <SuperAdminNavigationListItem text="Features" url="/superadmin/features" />}
                    <SuperAdminNavigationListItem text="NPS Score" url="/superadmin/nps" />
                </List>
            </NavigationContainer>
        </>
    );
};

export default SuperAdminNavigation;